/*默认图片*/
let defaultImg = require("@/assets/img/default.png");
export { defaultImg };



// WEBPACK FOOTER //
// ./src/config/env.js